<template>
  <div ref="root" class="relative">
    <Button variant="stroke" size="md" :icon="FilterIcon" @click="open = !open">
      {{ label }}
    </Button>
    <Transition name="popover-down">
      <div
        v-if="open"
        class="absolute left-0 top-[calc(100%+3px)] z-50 w-[240px]"
      >
        <Menu v-model="model" select="multiple">
          <Menu.Section label="Filter" />
          <Menu.Item
            v-for="category in categories"
            :key="category.value"
            :value="category.value"
          >
            {{ category.label }}
          </Menu.Item>
        </Menu>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { Button, Menu } from '@dacr/library'
import { FilterIcon } from '@dacr/icons'
import { FileCategory } from '@/shared/graphql/legacy/generated'
import { useEventListener } from '@/shared/composables/useEventListener'

const model = defineModel<FileCategory[]>({ default: () => [] })

const open = ref(false)
const root = ref<HTMLElement>()

const categories = [
  { label: 'Images', value: FileCategory.Images },
  { label: 'Video', value: FileCategory.Videos },
  { label: 'Audio', value: FileCategory.Audio },
  { label: 'Documents', value: FileCategory.Documents },
  { label: 'Code', value: FileCategory.Code },
  { label: 'Other', value: FileCategory.Other },
]

const label = computed(() =>
  model.value.length ? `Filter (${model.value.length})` : 'Filter'
)

useEventListener(window, 'click', (event: Event) => {
  if (!root.value?.contains(event.target as Node)) open.value = false
})
</script>
